import { alpha, IconButton, InputBase, makeStyles } from "@material-ui/core";
import { AttributesMixin, define } from "@type-r/models";
import { type } from "@type-r/models/lib/model";
import { useBoundLink, useModel } from "@type-r/react";
import { Input } from "lqx-react/lib";
import { FilterModel } from "./base-filter-model";

import AddIcon from '@material-ui/icons/Add';
import * as React from 'react';
import { useThrottle } from "@linked/controls";
import SearchIcon from '@material-ui/icons/Search';
export interface TextFilter extends AttributesMixin<typeof TextFilter>{}
@define
export class TextFilter extends FilterModel {
    static attributes = {
        ...FilterModel.attributes,
        value : type(String).required
    };

    delete() {
        this.value = undefined;
    }

    asLabel() {
        return this.value;
    }
}

export const EnterText = ({ onEnter }) => {
    const state = useModel(TextFilter);

    return <>
        <Input $value={ state.$.value }
                placeholder="Add filter"
                onKeyPress={ e => {
                    if( e.charCode === 13 ){
                        onEnter( state.clone() );
                    }
                }}
        />
        <IconButton
            aria-label="Add"
            size="small"
            onClick={ () => onEnter( state.clone() )}
        >
            <AddIcon />
        </IconButton>
    </>
}

/**
 * **SearchInput** is an special text input with search icon and throttled update of the enclosed value.
 * It updates the linked value after 1 second when user stopped typing.
 *
 * This input can be used to make an instant search and filtering on linked value change.
 */
 export const SearchInput = ({ $value, ...props }) => {
    const classes = useStyles();
    const $inputValue = useBoundLink( $value )
        .onChange(
            useThrottle(
                x => { $value.set( x.trim() ) },
                1000,
                [ $value.value ]
            )
        );

    return (
        <div className={classes.search}>
            <div className={classes.searchIcon}>
                <SearchIcon />
            </div>
            <InputBase
                placeholder="Search…"
                classes={{
                    root: classes.inputRoot,
                    input: classes.inputInput,
                }}
                inputProps={{ 'aria-label': 'search' }}
                { ...$inputValue.props }
                { ...props }
            />
        </div>
    )
}

const useStyles = makeStyles( theme => ({
    inputRoot: {
        color: 'inherit',
        width: '100%',
        display: 'flex'
      },
    inputInput: {
        paddingLeft: 24,
        transition: theme.transitions.create('width'),
        width: '100%',
        fontSize: 14
    },
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: alpha(theme.palette.common.white, 0.15),
        '&:hover': {
          backgroundColor: alpha(theme.palette.common.white, 0.25),
        },
        marginLeft: 0,
        width: '100%'
      },
      searchIcon: {
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',    
        right: '8px'
      },
      chip: {
        marginRight: 4,
        marginBottom: 4,
        overflow: 'hidden',
      }
}))